<script lang="ts">
	import Button from '$lib/components/atoms/button/Button.svelte';
	import Image from '$lib/components/atoms/image/Image.svelte';
	import Icon from '$lib/components/icons/Icon.svelte';
	import * as m from '$paraglide/messages';

	interface Props {
		text: string;
		withBorder?: boolean;
		errorImage?: string;
		onRetry?: () => void;
	}

	const {
		text,
		withBorder = false,
		errorImage = '',
		onRetry,
	}: Props = $props();

</script>

<div class={['p-4 bg-neutral-weakest rd-4 mb-4 m-auto', withBorder && 'border-2 border-solid border-error-weak shadow-first']}>
	{#if errorImage}
		<Image
			src={errorImage}
			alt={text}
			objectFit="contain"
			class="w-22 h-22 w-full"
		/>
	{:else}
		<Icon icon="bib-sad" class="h-8 m-auto w-full" />
	{/if}
	<div class="mt-0.5 mb-3 text-center text-sm">{text}</div>
	<div class="flex gap-4 justify-center">
		<Button icon="autorenew" text={m.action__retry()} onclick={onRetry} />
	</div>
</div>
